export const getAvatarColorByInitials = (colors: string[], initials?: string) => {
    let colorIndex = 0;
    if (initials) {
        let nameHash = 0;
        initials.split('').forEach((letter) => {
            const codePointAt = letter.codePointAt(0);
            if (codePointAt || codePointAt === 0) {
                nameHash += codePointAt;
            }
        });

        colorIndex = nameHash % colors.length;
    }

    return colors[colorIndex];
};

export const makeInitials = (name: string) => {
    if (!name) {
        return '';
    }
    return name
        .replace(/[^\w\s]/gi, '')
        .split(' ')
        .map((str) => str[0])
        .join('')
        .slice(0, 2) // only take the first 2 letters
        .toUpperCase();
};
